// extracted by mini-css-extract-plugin
export default {"container":"UnitToggle_container__P-+7e","tab":"UnitToggle_tab__k4F4X","active":"UnitToggle_active__nrOdP"};